import { type PimProductV11 } from '@redteclab/api/clients/bully'

export const productAccessorVariantHasOffers = (
  variant: PimProductV11,
): boolean => variant.offers?.length !== 0
